/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useCMSHeaderContent } from '../api/getCMSHeaderContent';

export const useGlobalAlertBanner = () => {
  const { data: cmsHeaderData } = useCMSHeaderContent();

  return {
    alertBannerContent: cmsHeaderData?.sitewideAlertBanner,
    isAlertBannerVisible: cmsHeaderData?.sitewideBanner && !!cmsHeaderData.sitewideAlertBanner,
  };
};
